import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CForm,CFormInput,CInputGroup,CInputGroupText,
	CButton,
	CImage,
	CCard,CCardHeader,CCardFooter,CCardBody,
	CLink,CTooltip,
	CDropdown,CDropdownItem,CDropdownToggle,CDropdownMenu,
	CSpinner,CBadge,
} from '@coreui/react';
import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import CIcon from '@coreui/icons-react';
import {
	MyDialogform,
	MyDialoglookup,
	MyPagination,
	MyPage500,
	MyButton,
} from '../components/index'
import { UFunc, cKeycodebypass } from '../helpers/functions'
import { Konfirm } from '../helpers/onConfirm';

const pjson 	= require('../../package.json')
const Pecahdata = (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uTokenObj				= JSON.parse(localStorage.getItem("token")||"{}");
	const uBahasaObj  			= useSelector(state => state.listBahasa);
	const uActiveroute  		= useSelector(state => state.activeRoute);
	const uEfekapp				= useSelector(state => state.effectApp);
	const uIsScrollBottom		= useSelector(state => state.gIsScrollBottom);
	const uUserSettingObj 		= useSelector(state => state.gListUserSetting);
	const uIsEOMExecuted		= useSelector(state => state.gIsEOMExecuted);
	const [uEfekview,setEfekview]= React.useState(false);
	const uSettingsystemObj		= useSelector(state => state.gSystemsetting);

	const uIsAllowedhapus		= uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN"
	const uMaxData				= isMobile ? (uUserSettingObj.jml_mobile || 10) : (uUserSettingObj.jml_tabel || 30);
	const uKeywordObj			= JSON.parse(localStorage.getItem("listkeyword")) || {};

	const uHeaderactionObj  	= useSelector(state => state.gInitHeaderAction);
	const uHandelView 			= uHeaderactionObj.isHeaderView || false;
	const uHeaderTambah 		= uHeaderactionObj.isHeaderTambah || false;

	/*//---PAGINATION_DIATUR_BACKEND--/
	const uTabelSelectObj 		= useSelector(state => state.gInitTabelSelected);
	const uIsInitbefore 		= (JSON.stringify(uTabelSelectObj||{})!=="{}");
	const [uInitbeforeprocess,setInitbeforeprocess] = React.useState(false);
	//---END PAGINATION_DIATUR_BACKEND--*/

	const [uHTMLError500,setHTMLError500]	= React.useState();
	const [uFirstload,setFirstload]			= React.useState("YA");
	const [uDatamainObj,setDatamainObj]		= React.useState([]);
	const [uPageActive,setPageActive]		= React.useState(1);
	const [uJmlData,setJmlData] 			= React.useState(0);
	const [uJmlHal,setJmlHal] 				= React.useState(1);
	const [uTabelRowSelect,setTabelRowSelect]= React.useState(-1);
	const [uTimeElapsed,setTimeElapsed]		= React.useState(0);
	const [uProsessingprogress,setProsessingprogress]= React.useState("");


	const [uISProcessingtutup,setProcessingtutup]	= React.useState(false);

	//--DIALOG_FORM--/
	const [uISDlgformshow,setDlgformshow]	= React.useState(false);
	const [uDlgformObj,setDlgformObj]		= React.useState({});
	//--END DIALOG_FORM--*/

	//--DLG_LOOKUP--/
	//--END DLG_LOOKUP--*/

	const uElJmldata			= document.getElementById("idjmldata");

	//---HANDLE--/
	const hdlKlikProsespecah = async() => {
		//--VALIDASI--/
		//--END VALIDASI--/

		if(await Konfirm(
			"<p><b>Anda Akan Melakukan Proses Pecah Data Tahunan</b>..</p>"+
			"<div class='mx-3 classfontsmaller fst-italic'>"+
			"<p>"+
				"Pecah Data Merupakan Proses Pemisahan DATA JURNAL dan DATA STOK Yang Sudah Lewat dan Tidak Terpakai Kembali. "+
				"Proses Ini dilakukan Agar Database Dapat Optimal Ketika Digunakan untuk Transaksi."+
			"</p>"+

			"<p>"+
				"Mohon Jangan Tinggalkan Halaman Ini dan Biarkan Browser Tetap Terbuka, "+
				"Ketika Proses Berlangsung."+
			"</p>"+
			"</div>"+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) apiProsespecah();
	}
	//---END HANDLE--/

	//---PROSES--/
	//---END PROSES--/

	//---CONTENT--/
	const contentInformasi = () => {
		if(uHTMLError500) return "";

		return (
		<div className="classpetunjuk px-0">
		<ol className="p-0 ps-4 m-0">
			<li className="mb-2">
				Memproses Pecah Tabel untuk data JURNAL dan MUTASI BARANG, agar Database menjadi optimal.
			</li>
			
			<li className="mb-2">
				Hanya Boleh dilakukan oleh SUPERUSER, dan diproses ketika TAHUN bersangkutan dinyatakan SELESAI menginput DATA.
			</li>
		</ol>
		</div>
		)//->
	}
	const contentMain = () => {
		if(uHTMLError500) return "";

		return (
		<>
		<div className="my-3 classborderbottom d-none">{JSON.stringify(uDatamainObj)}</div>
		<CRow className="my-3">
			<CCol xs="5">Tahun Terakhir Pecah Data</CCol>
			<CCol className="fw-bolder text-primary text-end">
			<big>
				{uDatamainObj.tahun_lastpecahdata ? uDatamainObj.tahun_lastpecahdata
					: (<CSpinner color="primary" size="sm"/>)}
			</big>
			</CCol> 
		</CRow>

		<CRow className="my-3">
			<CCol xs="5">Tgl Terakhir Pecah Data</CCol>
			<CCol className="fw-bolder text-primary text-end">
				{uDatamainObj.tgl_last_pecahdata 
					? UFunc.HariAngka(uDatamainObj.tgl_last_pecahdata) + " " +UFunc.JamMenitDetik(uDatamainObj.tgl_last_pecahdata) 
					: (<CSpinner color="primary" size="sm"/>)}
			</CCol> 
		</CRow>

		<div className="classborderbottom my-4"/>

		<CForm className="text-center">
			<MyButton onClick={()=>hdlKlikProsespecah()} id="btnProsespecah">
				Proses Pecah Data
			</MyButton>
		</CForm>
		</>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		return (<></>)//>
	}
	//---END CONTENT--/

	//---API--/
	const apiLoaddata = () => {
		setHTMLError500();
		const vElbutton	= document.getElementById("btnProsespecah");
		vElbutton && (vElbutton.disabled = true);

		setDatamainObj({});
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setDatamainObj(vTmpObj);
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_pecahdata/ld_init";

		setTimeElapsed(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true)
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(Pecahdata - apiLoaddata) vTabelid : "+vTabelid);
				const vLoadObj	= JSON.parse(output_string.dataobject||"{}")
				//--PAGINATION_DIATUR_FRONTEND--/
				setDatamainObj({
					tahun_lastpecahdata: vLoadObj.tahun_lastpecahdata || "2020",
					tgl_last_pecahdata: uSettingsystemObj.tgl_last_pecahdata || "2020-01-01 00:00:01",
				});
				//--END PAGINATION_DIATUR_FRONTEND--*/

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeElapsed(vTimeDiff);
			} else if(output_string.info) {
				setHTMLError500(output_string.info);
			} else if(output_string.errors) {
				console.log("(Pecahdata-apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHTMLError500("<font color='red'>"+vMsg+"</font>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			vElbutton && (vElbutton.disabled = false);
			setLoading(false);
			console.log("(Pecahdata-apiLoaddata) catch-error: "+error);
			setHTMLError500(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiProsespecah = () => {
		const vArrprocess	= [
			{ caption_target:"Proses Jurnal", url_target:pjson.homepage+"api/api_pecahdata/pr_jurnal" },
			{ caption_target:"Proses Stok", url_target:pjson.homepage+"api/api_pecahdata/pr_stok" },
		];

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});

		const processSequentially = async(_ARRPROSES) => {
			let vArrResults = [];

			for (const vProses of _ARRPROSES) {
				try {
					setSessionaktif(false);
					setProsessingprogress(vProses.caption_target);
					const response = await fetch(vProses.url_target, {
						headers: { Accept: "application/json", "Content-Type": "application/json" },
						method: "POST", mode: "cors",
						cache: "default",
						body: vDATAS,
					});

					console.log(`(Pecahdata - apiProsespecah) processSequentially ${vProses.caption_target} == ${UFunc.JamMenitDetik()}`)
					if (!response.ok) {
						throw new Error(`Failed to execute task at ${vProses.caption_target}`);
					}

					setSessionaktif(true);
					const output_string = await response.json();
					if (output_string.errors) {
						throw new Error(`${vProses.caption_target} [ERRORS]: ${output_string.errors}`);
					}
					if (output_string.info) {
						throw new Error(`${vProses.caption_target} [INFO]: ${output_string.info}`);
					}
					if(output_string.expired) {
						prosesExpired();
						throw new Error("{EXPIRED SESSION}");
					}

					vArrResults.push(output_string.sukses); // Add successful vArrResults
				} catch (err) {
					console.log(`(Pecahdata - apiProsespecah) processSequentially CATCH ${vProses.caption_target}: ${err.message} == ${UFunc.JamMenitDetik()}`);
			        throw err;
				}
			}
			return vArrResults;
		}

		(async () => {
			let vArrResults = [];
			const vElbutton	= document.getElementById("btnProsespecah");
			vElbutton && (vElbutton.disabled = true);
			setProcessingtutup(true);
			setLoading(true);
			try {
				setProsessingprogress("Preparing");
				console.log(`(Pecahdata - apiProsespecah) TRY ${UFunc.JamMenitDetik()}`);
				//--PREPARING--/
				setSessionaktif(false);
				const response = await fetch(pjson.homepage+"api/api_pecahdata/pr_preparing", {
					headers: { Accept: "application/json", "Content-Type": "application/json" },
					method: "POST", mode: "cors",
					cache: "default",
					body: vDATAS,
				});
				const output_string = await response.json();
				setSessionaktif(true);
				if (output_string.errors) {
					throw new Error(`Preparing Proses [ERRORS]: ${output_string.errors}`);
				}
				if (output_string.info) {
					throw new Error(`Preparing Proses [INFO]: ${output_string.info}`);
				}
				if(output_string.expired) {
					prosesExpired();
					throw new Error("{EXPIRED SESSION}");
				}
				//--END PREPARING--/
				
				try {
					const results = await processSequentially(vArrprocess);
					vArrResults.push(...results);
				} finally {
					setProsessingprogress("Finishing");
					setSessionaktif(false);
					const response = await fetch(pjson.homepage+"api/api_pecahdata/pr_finishing", {
						headers: { Accept: "application/json", "Content-Type": "application/json" },
						method: "POST", mode: "cors",
						cache: "default",
						body: vDATAS,
					});
					const output_string = await response.json();
					setSessionaktif(true);

					/*//--SEMENTARA_TEST--/
					console.log(`(Pecahdata - apiProsespecah) FINALLY ${vArrResults.length} === ${vArrprocess.length}`);
					console.log(`(Pecahdata - apiProsespecah) FINALLY ${JSON.stringify(vArrResults)} === ${vArrprocess.length}`);

					if (output_string.errors) {
						showToast(output_string.errors || 'Custom Error from Server',"ERROR");
						return;
					}
					if (output_string.info) {
						showToast(output_string.info || 'Custom INFO from Server',"ERROR");
						return;
					}
					if(output_string.expired) {
						prosesExpired();
						return;
					}
					//--END SEMENTARA_TEST--*/
		
					uDispatch({type: "set", gSystemsetting:JSON.parse(output_string.systemsetting||JSON.stringify(uSettingsystemObj))});
				}
			} catch (err) {
				//showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
				console.log(`(Pecahdata - apiProsespecah) CATCH ${err.message} ${UFunc.JamMenitDetik()}`)
				showToast(err.message || 'An unexpected error occurred',"ERROR");
			} finally {
				setProsessingprogress("");
				vElbutton && (vElbutton.disabled = false);

				console.log(`(Pecahdata - apiProsespecah) FINALLY ${UFunc.JamMenitDetik()}`)
				setProcessingtutup(false);
				setLoading(false);

				if(vArrResults.length > 0) {
					//console.log("(Pecahdata - apiProsespecah) uSettingsystemObj => "+JSON.stringify(uSettingsystemObj));
					showToast("<p><b>BERHASIL</b> !"+
						"<br/>Proses Pecah Data Telah Selesai.</p>"+
						"<p>Silahkan Lanjutkan Aktifitas Selanjutnya..</p>"+
						"","SUKSES");
				}

			}
		})();
	}
	//---END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

		//if(!uIsInitbefore) 
			apiLoaddata();

		return () => {
			setFirstload("YA");
			uDispatch({type: "set", gInitHeaderAction: {}});
			setDatamainObj({}); setProcessingtutup(false); setLoading(false);
		}
	},[])
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderactionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderactionObj});

		apiLoaddata();
	},[uHandelView]);
	React.useEffect(()=>{
		if(!uSettingsystemObj.tgl_last_pecahdata) return;

		setDatamainObj({...uDatamainObj,
			tgl_last_pecahdata: uSettingsystemObj.tgl_last_pecahdata
		});
	},[uSettingsystemObj,uSettingsystemObj.tgl_last_pecahdata]);
	
	console.log("Pecahdata - uDatamainObj => "+JSON.stringify(uDatamainObj));

	if(UFunc.isEmpty(uTokenObj)) { setLoading(true); prosesExpired(); return "" }
	if(uHTMLError500) return ( <MyPage500 content={uHTMLError500}/> )//>

	return (
	<>
		{uISProcessingtutup && (
			<CBadge className="position-fixed fst-italic classblinking p-2 text-center"
				color="danger"
				style={{zIndex:1092,top:"50%",left:"50%",transform:"translate(-50%,30px)"}}>
				<p>Mohon Ditunggu,
				<br/>Jangan Tutup Browser Anda...</p>
				
				<small className="text-uppercase text-warning">
					&middot;&middot;{uProsessingprogress}&middot;&middot;
				</small>
			</CBadge>
		)}

		<CRow className="align-items-stretch">
		<CCol md="6" className="mb-3">
		<CCard className="classcardbg h-100">
			<CCardHeader className="classfontsmaller">
				Informasi Pecah Data
			</CCardHeader>

			<CCardBody>{contentInformasi()}</CCardBody>
		</CCard>
		</CCol>

		<CCol className="mb-3">
			<CCard className="classcardbg h-100">
			<CCardHeader className="classfontsmaller">
				Proses Pecah Data
			</CCardHeader>

			<CCardBody>{contentMain()}</CCardBody>
			</CCard>
		</CCol>
		</CRow>
	</>
	)//>
}	

export default Pecahdata